import React from 'react';
import { useClientFeatures } from '../../hooks/useClientFeatures';
import { MiniUpgradePrompt } from './UpgradePrompt';

interface ClientFeatureGateProps {
  feature: string;
  featureName: string;
  requiredTier: string;
  children: React.ReactNode;
}

export const ClientFeatureGate: React.FC<ClientFeatureGateProps> = ({
  feature,
  featureName,
  requiredTier,
  children
}) => {
  const { hasFeature } = useClientFeatures();
  
  if (!hasFeature(feature as any)) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
        <h3 className="text-lg font-medium text-gray-900 mb-2">{featureName}</h3>
        <p className="text-sm text-gray-600 mb-4">
          This feature requires a {requiredTier} plan or higher.
        </p>
        <MiniUpgradePrompt />
      </div>
    );
  }
  
  return <>{children}</>;
};